import { Edition } from "@shapeable/gesda-types";
import { useEditions } from "./use-editions";
import { maxBy, toNumber } from 'lodash';

export const useCurrentEdition: () => Edition = () => {
  const editions = useEditions();
  if (process.env.CURRENT_EDITION) {
    const numericEdition = toNumber(process.env.CURRENT_EDITION)
    if (numericEdition) {
      return {
        id: process.env.CURRENT_EDITION,
        name: process.env.CURRENT_EDITION,
        numericValue: numericEdition,
      };
    }
  }

  return maxBy(editions, edition => edition.numericValue || toNumber(edition.name));
};
